import { NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
/**
 * Block data interface
 */
export type ISearchOutletBlockData = Catalog.IBlockData<ISearchOutletBlockContent>;
export interface IPopularSearchesItem {
    title: string;
    link: string;
}
export interface ITrendingNowItem extends IPopularSearchesItem {
    image: string;
    link_text: string;
}
/**
 * Block content interface
 */
export interface ISearchOutletBlockContent {
    popular_searches_title: string;
    popular_searches_items: IPopularSearchesItem[];
    additional_title: string;
    additional_items: IPopularSearchesItem[];
    trending_now_title: string;
    trending_now_items: ITrendingNowItem[];
}
let uid = 0;

/**
 * Component definition
 */
@ICmsComponent<SearchOutletBlockComponent>({
    id: 'search-outlet-block',
    block: {
        url: 'search-outlet-block'
    },
    onDemandOnly: true,
    name: 'Search Outlet Block',
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'popular_searches_label',
            title: 'Popular Searches'
        },
        <NICmsContentField.IField>{
            key: 'popular_searches_title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'popular_searches_items',
            title: 'Items',
            itemName: 'Line',
            itemNameField: 'text',
            fields: [
                <NICmsContentField.IField>{
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Text',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link',
                    required: true
                }
            ]
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'additional_label',
            title: 'Additional'
        },
        <NICmsContentField.IField>{
            key: 'additional_title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'additional_items',
            title: 'Items',
            itemName: 'Line',
            itemNameField: 'text',
            fields: [
                <NICmsContentField.IField>{
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Text',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link',
                    required: true
                }
            ]
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'trending-now-label',
            title: 'Trending Now'
        },
        <NICmsContentField.IField>{
            key: 'trending_now_title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'trending_now_items',
            title: 'Items',
            itemName: 'Line',
            itemNameField: 'text',
            maxSize: 3,
            fields: [
                <NICmsContentField.IField>{
                    key: 'image',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image',
                    reqired: true
                },
                <NICmsContentField.IField>{
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Text',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'link_text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link Text',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link',
                    required: true
                }
            ]
        }
    ]
})
@Component({
    selector: 'search-outlet-block',
    templateUrl: './search-outlet-block.html',
    standalone: true,
    imports: [
        HrefComponent,
        ICmsClientModule,
        ImageModule,
        NgClass,
        NgFor,
        NgIf,
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
        RouterLink,
        SizeClassDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchOutletBlockComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content: ISearchOutletBlockData;
    @Input()
    popularSearches?: string[];
    protected canDetach = true;
    protected uid = uid++;
}
